import React from "react";
import {WarningOutlined,LoadingOutlined} from '@ant-design/icons'
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Обновить состояние с тем, чтобы следующий рендер показал запасной UI.
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            // Можно отрендерить запасной UI произвольного вида
            return <LoadingOutlined />;
        }

        return this.props.children;
    }
}
export default ErrorBoundary;